import * as CONSTANTS from '../modules/constants';
import { Accordions } from '../../../lib/lib-javascript/accordion/accordions';
import { svgInject } from '../modules/svg-injection';
import { alertBar } from '../modules/alert';
import { loginState } from '../modules/login-state';
import { NavMain } from '../modules/nav-main';
import { NavMobile } from '../modules/nav-mobile';
import { searchState } from '../modules/utility-search';
import { nodeListToArray } from '../modules/nodelist-to-array';
import * as A11yDialog from 'a11y-dialog';
import { swapImage } from '../modules/_img-swap';
import { throttle, debounce } from 'lodash';
import { enhanceEpiForms } from '../modules/epi-forms';
import { setupTextExpanders } from '../modules/expand-text';
import { multimediaBlock } from '../modules/multimedia-block';

(function() {
    // Request SVG sprite
    let spritePath = (window as any).SVG_SPRITE_PATH || '/static/imgs/svg/svg-sprite.svg';
    svgInject(spritePath);

    const mainNav = new NavMain(nodeListToArray(document.querySelectorAll('#nav-main .nav-main-list-item > span')));

    // Mobile Navigation
    const mobileNav = new NavMobile(CONSTANTS.GLOBAL_BODY);

    // run on document ready
    document.addEventListener('DOMContentLoaded', function() {
        new alertBar(document.getElementById('alert-bar'));
    });

    loginState();

    multimediaBlock();

    if (mobileNav) {
        searchState(closeNav);
    }

    function closeNav() {
        mobileNav.closeNav();
    }

    // Accordions
    new Accordions({ singleAccordion: true });

    // Modals!
    let modals = Array.prototype.slice.call(document.querySelectorAll('.a11y-modal-js'));
    modals.forEach(modal => {
        let modalId = modal.getAttribute('id');
        if (modal.classList.contains('multimedia-modal-wrapper') && modalId) {
            (window as any)[modalId] = new A11yDialog(modal);
        } else {
            new A11yDialog(modal);
        }
    });

    //EPI Forms
    if (document.querySelector('.EPiServerForms')) {
        enhanceEpiForms();
    }

    //read more expand/collapse text
    setupTextExpanders();

    // window.addEventListener(
    //     'resize',
    //     debounce(() => {
    //         //single resize listener
    //     }, 50)
    // );
})();



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/common/global.ts